import { render } from "./RegisterEndorserModalBibo.vue?vue&type=template&id=343cde79"
import script from "./RegisterEndorserModalBibo.vue?vue&type=script&lang=ts"
export * from "./RegisterEndorserModalBibo.vue?vue&type=script&lang=ts"
script.render = render

export default script